import { Step, StepConnector, StepContent, StepLabel, Stepper } from '../primitives/index.js'
import { Typography } from '../primitives/index.js'
import { graphHooks } from '@tunasong/graph-lib/react'
import type { FeedItem } from '@tunasong/models'
import { dayjs } from '@tunasong/models'
import cn from 'classnames'
import type { FC, HTMLAttributes } from 'react'
import { UserAvatar } from '../profile/index.js'
import { useScroll } from './scroll.js'
import styles from './feed.module.css'

export interface FeedProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
  title?: string
  items: FeedItem[]
  maxItems?: number
  topRef?: React.RefCallback<HTMLDivElement>
}

export const Feed: FC<FeedProps> = props => {
  const { className, topRef, title, maxItems = Number.MAX_SAFE_INTEGER, items = [], style, ...divProps } = props

  const userIds = items.map(i => i.userId)
  const { getName } = graphHooks.useProfiles({ userIds })

  const showItems = items.slice(0, maxItems)

  const { highlightId } = useScroll(items)

  return (
    <div style={style} className={cn(styles.root, className)} {...divProps}>
      {title ? <Typography variant="subtitle1">{title}</Typography> : null}

      {showItems.length > 0 ? (
        <Stepper
          orientation="vertical"
          connector={<StepConnector className={styles.stepConnector} />}
          className={styles.stepper}
        >
          {showItems.map((item, idx) => (
            <Step
              key={idx}
              ref={idx === 0 ? topRef : null}
              active={true}
              className={item.id && item.id === highlightId ? styles.highlight : undefined}
            >
              <StepLabel
                slots={{
                  stepIcon: () => <UserAvatar userId={item.userId} size="small" />,
                }}
              >
                <div className={styles.labelContent}>
                  <Typography variant="body2">{getName(item.userId)}</Typography>
                  <Typography variant="caption">{dayjs(item.createdAt).fromNow()}</Typography>
                </div>
              </StepLabel>
              <StepContent>
                <div className={styles.stepContent}>{item.content}</div>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      ) : (
        <Typography variant="caption">Messages will appear here - use the Chat box below</Typography>
      )}
    </div>
  )
}

export default Feed
